import React, { useState, useEffect } from "react";
import { Typography, TextField, Button, Grid, Stepper, Step, StepLabel, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel } from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Datos de la Infracción", "Asignar Vehículo"];

const EditarInfraccion = ({ infraccion, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [infraccionData, setInfraccionData] = useState({
    descripcion: "",
    fecha: "",
    monto: "",
    vehiculo: "",
    pagada: "",
    codigo_multa: "",
    lugar_radicacion: "",
  });
  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  useEffect(() => {
    if (infraccion) {
      setInfraccionData({
        descripcion: infraccion.descripcion,
        fecha: infraccion.fecha,
        monto: infraccion.monto,
        pagada: infraccion.pagada === true || infraccion.pagada === "true" || infraccion.pagada === 1,
        vehiculo: infraccion.vehiculo || "",
        codigo_multa: infraccion.codigo_multa || "",
        lugar_radicacion: infraccion.lugar_radicacion || "",
      });
    }
  }, [infraccion]);

  useEffect(() => {
    const { descripcion, fecha, monto } = infraccionData;
    setIsStep1Valid(descripcion && fecha && monto);
  }, [infraccionData]);

  const handleChange = (e) => {
    setInfraccionData({ ...infraccionData, [e.target.name]: e.target.value });
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Ensure pagada is a boolean or numeric value
    const updatedInfraccionData = {
      ...infraccionData,
      pagada: infraccionData.pagada ? true : false, // Ensure this is a boolean value
    };
  
    console.log("Pagada before submitting:", updatedInfraccionData.pagada);
  
    api.put(`infracciones/${infraccion.id}/`, updatedInfraccionData)
      .then((res) => {
        alert("Infracción actualizada correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al actualizar la infracción."));
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Infracción
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={6}>
            <TextField
              label="Código de Multa"
              name="codigo_multa"
              value={infraccionData.codigo_multa}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Lugar de Radicación"
              name="lugar_radicacion"
              value={infraccionData.lugar_radicacion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Descripción"
              name="descripcion"
              value={infraccionData.descripcion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Fecha"
              name="fecha"
              type="date"
              value={infraccionData.fecha}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Monto"
              name="monto"
              type="number"
              value={infraccionData.monto}
              onChange={handleChange}
              fullWidth
              required
            />
            </Grid>
            <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={infraccionData.pagada}
                  onChange={(e) =>
                    setInfraccionData({ ...infraccionData, pagada: e.target.checked })
                  }
                  name="pagada"
                />
              }
              label="Pagada"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo Asignado</InputLabel>
              <Select
                name="vehiculo"
                value={infraccionData.vehiculo}
                onChange={handleChange}
              >
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((vehiculo) => (
                  <MenuItem key={vehiculo.id} value={vehiculo.id}>
                    {vehiculo.patente} - {vehiculo.marca} {vehiculo.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarInfraccion;
